<template>
  <div class="content">
      <slot></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
$background-1: rgba(61, 143, 238);
$background-2: rgba(124, 184, 255);
.content{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $background-2;
  min-height: 240px;
  flex-grow: 1;
}
</style>